import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./styles.module.scss";
import Timer from "../Timer";
import { I18n } from "@td/shared_utils";

const Status = React.memo(({ status, startedAt }) => {
  const isActive = status === "IN_PROGRESS";

  return (
    <div className={cx(styles.conferenceStatusContainer, isActive && styles.conferenceActive)}>
      <div
        className={styles.conferenceStatus}
        data-testid="waiting-room-sidebar-status-text"
      >
        <I18n scope="call_details.call_status" text={isActive ? "in_progress" : "not_started"} />
      </div>
      <div className={styles.conferenceDuration}>
        {isActive && (
          <Timer
            startedAt={startedAt}
          />
        )}
      </div>
    </div>
  );
});

Status.displayName = "Status";

Status.propTypes = {
  status: PropTypes.string,
  startedAt: PropTypes.string,
};

export default Status;
